import { createContext, RefObject } from "react";

/**
 * The project table's own scrollable container, provided once by ProjectTable and
 * read by ActionMenuCell so its action menu can flip upward before it would run past this
 * container's own bottom edge — not just the browser window's, which NewActionMenu checks by
 * default. Without this, opening the menu on one of the last visible rows lets it drop down past
 * the table's own horizontal scrollbar, which then paints on top of it.
 */
export const TableScrollContainerContext = createContext<RefObject<HTMLDivElement> | null>(null);
